var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading)?_c('v-skeleton-loader',{attrs:{"type":"card"}}):_c('PostForm',{attrs:{"post":_vm.normalizedPost}})}
var staticRenderFns = []

export { render, staticRenderFns }